import forge from 'node-forge';

const encrypt = function (message, publicKey) {
    const oPublicKey = forge.pki.publicKeyFromPem(publicKey);

    const msg = oPublicKey.encrypt(message, "RSA-OAEP", {
        md: forge.md.sha256.create(),
        mgf1: forge.mgf1.create()
    });

    return forge.util.encode64(msg);
};

export default encrypt;
